import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
interface IProductFeaturesProps {
  productKey: string;
}
// 요금제별 기능 목록 (priceType은 URL 쿼리에서 파생 — 폼 컨텍스트 비의존)
const ProductFeatures = ({ productKey }: IProductFeaturesProps) => {
  const [toggleMoreInfoOn] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const priceType = searchParams.get("type") ?? "premium";
  const { t } = useTranslation();
  return (
    <>
      {Array.from(Array(3).keys())
        .filter(
          (item2, index2) =>
            (!toggleMoreInfoOn && index2 < 3) || toggleMoreInfoOn
        )
        .map((item, index1) => (
          <div className="text text--lg mg mb-16" key={index1}>
            <i className="icon_check_info inline-block vertical-middle" />
            <span className="terms inline-block vertical-middle mg ml-10 text text--14">
              {t(
                "subscriptionType.terms." +
                  productKey +
                  "." +
                  priceType +
                  "_" +
                  (index1 + 1)
              )}
            </span>
          </div>
        ))}
    </>
  );
};

export default ProductFeatures;
